<template>
  <div>
    <div class="collect-container" @click="handleClick">
      <img :src="sectionIcon" class="collect-icon" />
      <bi-button label="周期配置" type="text" />
    </div>
    <el-dialog
      title="周期配置"
      :visible.sync="dialogVisible"
      width="820px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div class="section-config-container" v-loading="loading">
        <div class="config-row">
          <span class="label">周期天数:</span>
          <el-input
            class="input"
            v-model="cycleDays"
            size="small"
            :class="{
              'interval-input': true,
            }"
            @input="
              (cycleDays = getNumberData(1, $event, 0, 0)),
                handleCycleDaysChange()
            "
          ></el-input
          >&nbsp;&nbsp;天
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          :loading="sureBtnloading"
          @click="handleConfirm"
          >确 认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  queryCycleConfig,
  saveCycleConfig,
} from "@/api/bi/reviewReport/sectionConfig.js";
import sectionIcon from "@/assets/images/report/section.svg";

export default {
  name: "SectionCycle",
  props: {
    type: {
      type: String,
      default: "",
    },
  },
  computed: {
  },
  data() {
    return {
      sectionIcon,
      dialogVisible: false,
      loading: false,
      sureBtnloading: false,
      cycleDays: 360,
      cycleDaysList: {},
      paramsData: {
        customer: 360,
        member: 360,
      },
    };
  },
  mounted() {},
  watch: {},
  methods: {
    querySectionConfigFn() {
      this.loading = true;
      queryCycleConfig({ type: 24 }).then((res) => {
        console.log("queryCycleConfig", res.data);
        if ( res.code == 1 && res.data) {
          this.cycleDaysList = JSON.parse(res.data) || {};
          console.log(this.cycleDaysList);
          this.cycleDays = this.cycleDaysList[this.type] ;
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    getNumberData(type, e, decimal = 0, min = 1, max = 9999999) {
      const str = type ? String(e) : String(e.target.value);
      let num = decimal
        ? str.replace(/[^\d.]/g, "").replace(/^(\-?\d+(?:\.\d{0,2})?).*$/, "$1")
        : str.replace(/[^\d]/g, "");

      if (num < min) num = "";
      if (max !== -1 && Number(num) > max) num = String(max);

      return Number(num) || "";
    },
    handleCycleDaysChange(val) {
      // this.cycleDays = val;
      console.log(val);
    },
    handleConfirm() {
      this.sureBtnloading = true;
      this.cycleDaysList[this.type] = this.cycleDays;
      let params = {
        type: 24,
        data: this.cycleDaysList,
      };
      saveCycleConfig(params)
        .then((res) => {
          console.log("saveCycleConfig", res.data);
          if (res.code == 200 || res.code == 1) {
            this.$message.success("保存成功");
            this.handleClose();
          }
        })
        .finally(() => {
          this.sureBtnloading = false;
        });
    },
    handleClick() {
      // this.$emit("sectionClick");
      this.dialogVisible = true;
      this.querySectionConfigFn();
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.collect-container {
  display: flex;
  align-items: end;
  cursor: pointer;
  .collect-icon {
    width: 20px;
    height: 20px;
    margin-right: 4px;
    transform: translateY(3px);
  }
}
.section-config-container {
  // padding: 10px;
  max-height: 600px;
  overflow-y: auto;

  .config-row {
    margin-bottom: 20px;
    display: flex;
    align-items: center;

    .label {
      font-weight: bold;
      margin-right: 15px;
      min-width: 80px;
      text-align: right;
    }
    .input {
      width: 100px;
    }
    &.interval-row {
      align-items: flex-start;
    }

    .static-num {
      padding: 0 5px;
      font-weight: bold;
      margin-bottom: 8px;
      margin-top: 2px;
    }
    .interval-inputs {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      flex: 1;
      margin-top: -8px;

      .interval-item {
        display: inline-flex;
        align-items: center;
        margin-bottom: 10px;
      }

      .separator {
        margin: 0 5px;
      }
      .op0 {
        opacity: 0;
      }

      .interval-input {
        width: 80px;
      }
    }

    .range-display {
      margin-left: 95px; /* Matches label width + margin */
      background-color: #fafafa;
      padding: 10px;
      border-radius: 4px;
      color: #666666;
      line-height: 1.8;
      width: 100%;
    }
  }
}
</style>
